import PendoMultiselectFilter from '../../multiselect-filter/pendo-multiselect-filter.vue.js';
import PendoButton from '../../../components/button/pendo-button.vue.js';
import get from 'lodash/get.js';

var script = {
  name: 'PendoGuideAlertsFilterBar',
  components: {
    PendoMultiselectFilter,
    PendoButton
  },
  props: {
    filterConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      filterOptions: {
        alertStatuses: [{
          id: 'NotReviewed',
          name: 'Not Reviewed'
        }, {
          id: 'Triage',
          name: 'Triage'
        }, {
          id: 'Resolved',
          name: 'Resolved'
        }],
        errorTypes: ['Page Mismatch', 'Element Missing', 'Other']
      },
      errorTypes: [],
      alertStatuses: []
    };
  },
  computed: {
    filters() {
      const {
        errorTypes,
        alertStatuses
      } = this;
      const filters = [{
        prop: 'errorType',
        value: errorTypes
      }, {
        prop: 'alertStatus',
        value: alertStatuses.map(status => status.id)
      }];
      return filters;
    },
    areFiltersSet() {
      return !!this.errorTypes.length || !!this.alertStatuses.length;
    }
  },
  watch: {
    filters: {
      immediate: true,
      handler() {
        this.$emit('on-update-filters', this.filters);
      }
    }
  },
  created() {
    const filters = get(this.filterConfig, 'value', {});
    this.errorTypes = get(filters, 'errorTypes', []);
    this.alertStatuses = get(filters, 'alertStatuses', []);
  },
  methods: {
    updateExpansionFilters() {
      const filters = {
        alertStatuses: this.alertStatuses,
        errorTypes: this.errorTypes
      };
      const settings = {
        name: 'displayAlertExpansionFilters',
        namespaced: true,
        value: filters,
        force: true
      };
      this.$emit('update-user-settings', settings);
    },
    clearFilters() {
      this.errorTypes = [];
      this.alertStatuses = [];
      this.updateExpansionFilters();
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-alerts-filter.vue2.js.map
